<template>
	<v-container fluid class="pa-0 pa-md-3 full-height grey lighten-2 justify-center" fill-height>
		<v-row class="mx-4">
			<v-col class="d-flex align-center flex-column text-center px-12">
				<div style="max-height: 290px">
					<lottie-vue-player src="/img/animations/403-error.json"
									   autoplay
									   :backgroundColor="colors.grey.lighten2"
									   loop
									   style="width: 100%; height: 100%">
					</lottie-vue-player>
				</div>
				
				<rmp-text type="body-large" class="mt-12" :color="colors.secondary.lighten1">
					{{ $t("alerts.errors.accessDenied") }}.
					Вы можете
					<a @click="signOut">
						сменить аккаунт
					</a>
					<template v-if="canGoBack">
						или
						<a @click="$router.go(-1)">
							вернуться назад.
						</a>
					</template>
				
				</rmp-text>
			</v-col>
		</v-row>
	</v-container>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { computed } from "vue";
import { useUser } from "@rmp/core/composables/useUser";

const { signOut } = useUser();

const canGoBack = computed(() => {
	return history.length > 2;
});

const { colors } = useColors();
</script>
